import { HelpCircle } from "lucide-react";
import { useTour } from "./TourContext";

/**
 * Small "?" button placed in page headers. Relaunches the guided tour that
 * matches the page (tourId from /lib/tours) without going through Help.
 */
export default function TourReplayButton({ tourId }) {
  const { startTour, activeTour } = useTour();
  if (activeTour) return null;
  return (
    <button
      type="button"
      onClick={() => startTour(tourId)}
      title="Show me how — start the tutorial"
      aria-label="Start the tutorial for this page"
      className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-emerald-600 text-white hover:bg-emerald-700 transition-colors"
      data-testid={`tour-replay-${tourId}`}
    >
      <HelpCircle className="h-4 w-4" />
    </button>
  );
}
